import { ModalData } from '@/types/modals';
import { create, StoreApi, UseBoundStore } from 'zustand';

interface ModalState {
  activeModals: ModalData[] | null;
  addModal: (modal: ModalData) => void;
  openModal: (modal: ModalData) => void;
  removeModal: (name: string) => void;
  closeModal: () => void;
}

const useModalStore: UseBoundStore<StoreApi<ModalState>> = create((set) => ({
  activeModals: null,
  addModal: (modal: ModalData) => {
    set((state) => ({
      activeModals: state.activeModals?.length
        ? [...state.activeModals, modal]
        : [modal],
    }));
  },
  openModal: (modal: ModalData) => {
    set(() => ({
      activeModals: [modal],
    }));
  },
  removeModal: (name: string) => {
    set((state) => ({
      activeModals: state.activeModals?.length
        ? [...state.activeModals.filter((m) => m.name !== name)]
        : null,
    }));
  },
  closeModal: () => {
    set(() => ({
      activeModals: null,
    }));
  },
}));

export default useModalStore;
